import Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);
moment.updateLocale('ko', {
  week: {
    dow: 1, // 한 주의 시작 요일은 월요일(1)
    doy: 4, //  연도의 첫 주는 1월 3일을 포함해야 될 경우. (계산 식: 7+dow-3)
  },
});

const formatStr = 'YYYY-MM-DD';

export const today = moment();
export const todayStr = today.format(formatStr);
export const fDate = (date) => moment(date).format(formatStr);
export const thisYear = moment().year();

export const getYearOptions = (prevDif, nextDif) => {
  const years = [];
  const today = new Date();
  const nowYear = today.getFullYear();

  const firstYear = Number(nowYear) - Number(prevDif);
  const lastYear = Number(nowYear) + Number(nextDif);

  for (let index = firstYear; index <= lastYear; index++) {
    years.push(index);
  }

  return years;
};

// 포캐스팅 검색
export const defaultStrDt = moment(new Date()).subtract(4, 'months');
export const subYearStrDt = (year) => {
  return moment(new Date()).subtract(year, 'years');
};

export const defaultStrtDt = moment(today)
  .subtract(3, 'months')
  .startOf('month');
export const defaultStrtDtStr = defaultStrtDt.format(formatStr);
// 목록 검색의 기본 조회범위(작년 오늘 ~ 내년 오늘). 영업 진행 현황 · 프로젝트 관리 ·
// 유지보수 관리가 함께 쓴다.
//
// 금년 1/1~12/31로 잡으면 연초에 화면이 비어 보이고, 매출 예정일이 작년인 건이 통째로 빠진다.
// 그래서 한동안 "작년 오늘 ~ 오늘"로 뒀는데, 그러면 이번에는 <b>앞으로 잡힌 건이 안 보인다</b>.
// 매출 예정일·계약 종료일은 대개 미래 날짜라 기본 조회에서 빠지는 쪽이 오히려 많았다.
// 뒤로도 1년을 열어 앞뒤 대칭으로 둔다.
export const recentOneYearStr = moment(today).subtract(1, 'years').format(formatStr);
export const recentOneYearEndStr = moment(today).add(1, 'years').format(formatStr);

export const firstDayofYear = moment(today).startOf('year').format(formatStr);
export const lastDayofYear = moment(today).endOf('year').format(formatStr);

export const getFirstDayOfYear = (paramDate) =>
  moment(paramDate).startOf('year').format(formatStr);
export const getLastDayOfYear = (paramDate) =>
  moment(paramDate).endOf('year').format(formatStr);

// 달 계산
export const selectMonth = (paramDate, diff) =>
  moment(paramDate).add(diff, 'M');

//달의 첫째, 마지막 날 가져오기
export const getFirstDay = (paramDate) => moment(paramDate).startOf('month');
export const getEndDay = (paramDate) => moment(paramDate).endOf('month');

export const getMonthRange = (start, end) => {
  return moment.range(start, end);
};

export const getHeaderRowsByTyp = (strtDt, endDt, type) => {
  let arr;
  const start = moment(strtDt);
  const end = moment(endDt);
  if (type === 'months') {
    arr = getMonthsRange(start, end);
  } else if (type === 'weeks') {
    arr = getWeekRange(start, end);
  } else if (type === 'days') {
    arr = getDaysRange(start, end);
  }
  return arr;
};

const getMonthsRange = (start, end) => {
  const months = [];
  const diff = end.diff(start, 'months');
  //console.log(diff, 'diff');
  for (let i = 0; i <= diff; i++) {
    let month = moment(start).add(i, 'months');
    let obj = {
      title: month.format('YYYY년 MM월'),
      value: month.format('YYYY-MM'),
    };
    months.push(obj);
  }
  return months;
};

const getWeekRange = (start, end) => {
  const weeks = [];
  const diff = end.diff(start, 'months');

  for (let i = 0; i <= diff; i++) {
    const month = moment(start).add(i, 'months');
    const monthWeeks = getWeeksOfMonth(month);

    weeks.push(...monthWeeks);
  }
  return weeks;
};

const getDaysRange = (start, end) => {
  const days = [];

  const diff = end.startOf('day').diff(start.startOf('day'), 'days');
  //console.log(diff, 'diff');

  for (let i = 0; i <= diff; i++) {
    let day = moment(start).add(i, 'days');
    let obj = {
      title: day.format('YYYY년 MM월 DD일'),
      value: day.format('YYYY-MM-DD'),
    };
    days.push(obj);
  }
  return days;
};

//주차는 월요일부터 시작임.
export const getWeeksOfMonth = (paramDate) => {
  let weeks = [];
  const firstDay = getFirstDay(moment(paramDate));
  const lastDay = getEndDay(moment(paramDate));
  // 0: 일, 1: 월, 2: 화. 3: 수, 4: 목, 5: 금, 6: 토.
  const monthName = moment(paramDate).format('YYYY년 MM월');
  const monthValue = moment(paramDate).format('YYYYMM');

  //let i = 1;
  const monthRange = moment.range(firstDay, lastDay);
  Array.from(monthRange.by('day')).map((d) => {
    let obj = {};

    //첫주 또는 마지막주의 달이 서로 다름.
    if (
      moment(d).startOf('week').format('MM') !==
      moment(d).endOf('week').format('MM')
    ) {
      if (
        moment(d).startOf('week').format(formatStr) === d.format(formatStr) ||
        moment(d).endOf('week').format(formatStr) === d.format(formatStr)
      ) {
        //마지막 날짜 체크
        const checkMonthLastWeek = addMonthIsLastDayBeforeThursday(lastDay);
        if (checkMonthLastWeek) {
          let weekNum = Math.ceil(moment(d).date() / 7);
          weekNum =
            moment(d).endOf('week').format(formatStr) !==
            moment(d).format(formatStr)
              ? weekNum + 1
              : weekNum;
          obj.startWeekDay = moment(d).startOf('week').format(formatStr);
          obj.endWeekDay = moment(d).endOf('week').format(formatStr);
          obj.weekNum = weekNum;
          obj.title = `${monthName} ${weekNum}주차`;
          obj.value = `${monthValue}${weekNum}`;
          weeks.push(obj);
        }
      }
    } else {
      if (moment(d).endOf('week').format(formatStr) === d.format(formatStr)) {
        let weekNum = Math.ceil(moment(d).date() / 7);

        weekNum = !subMonthIsFirstDayBeforeThursday(firstDay)
          ? weekNum - 1
          : weekNum;

        obj.startWeekDay = moment(d).startOf('week').format(formatStr);
        obj.endWeekDay = d.format(formatStr);
        obj.weekNum = weekNum;
        obj.title = `${monthName} ${weekNum}주차`;
        obj.value = `${monthValue}${weekNum}`;
        weeks.push(obj);
      }
    }
  });
  return weeks;
};

const subMonthIsFirstDayBeforeThursday = (firstDay) => {
  let result = true;

  if (moment(firstDay).day() > 4) {
    result = false;
  }
  //console.log(moment(lastDay).format(formatStr), moment(lastDay).day(), moment(lastDay) >= 1 && moment(lastDay).day() < 4, result)
  return result;
};

//마지막주의 마지막 날짜가 목요일보다 작으면 다음달로 넘김.
const addMonthIsLastDayBeforeThursday = (lastDay) => {
  let result = true;

  if (moment(lastDay).day() < 4) {
    result = false;
  }
  //console.log(moment(lastDay).format(formatStr), moment(lastDay).day(), moment(lastDay) >= 1 && moment(lastDay).day() < 4, result)
  return result;
};
